import EnumItem, {enumMixn} from "./enumItem";

/**
 * 枚举类别
 */
let EnumEntity = {
    Basin: new EnumItem('流域', 1),
    Agreement: new EnumItem('协议', 2),
    Measuring: new EnumItem('测量类型', 3),
    ComponentProduct: new EnumItem('因子组', 4),
    Organization: new EnumItem('组织', 5),
    User: new EnumItem('用户', 6),
    Role: new EnumItem('角色', 7),
    Saas: new EnumItem('Saas', 8),
    Component: new EnumItem('组分', 9),
    Station: new EnumItem('站点', 10),
    DeclareType: new EnumItem('申报类型', 11),
    // 根据设备id 查询组分
    ComponentById: new EnumItem('组分', 12),
    Company: new EnumItem('处理单位', 13),
    //资料类别
    DataManagement: new EnumItem('资料类别', 14),
    //视频密钥
    VideoKey: new EnumItem('视频密钥', 15),
    //根据站点id查询NVR信息
    NvrInfo: new  EnumItem('NVR信息', 16),
    //根据因子组id查询因子信息
    ComponentDetails: new  EnumItem('因子组详情', 17),
	...enumMixn
}
export default EnumEntity
